import { getFeatureConfig } from '@luna/feature-config';

function formatPhoneNumberCZ(countryCode: string, areaCode: string, phoneNumber: string): string {
    let rstr = '';
    if (countryCode) {
        rstr += `${countryCode} `;
    }
    if (areaCode) {
        rstr += `${areaCode} `;
    }
    if (phoneNumber) {
        rstr +=
            String(phoneNumber)
                .match(/.{1,3}/g)
                ?.join(' ') || '';
    }
    return rstr;
}

export function formatPhoneNumber(
    countryCode: string,
    areaCode: string,
    phoneNumber: string,
): string {
    if (getFeatureConfig((config) => config.base.country) === 'CZ') {
        return formatPhoneNumberCZ(countryCode, areaCode, phoneNumber);
    }

    let rstr = '';
    if (countryCode) {
        rstr += `${countryCode}/`;
    }
    if (areaCode) {
        rstr += `${areaCode}/`;
    }
    rstr += phoneNumber;
    return rstr;
}

export function decoratePhoneNumber(phoneNumber = ''): string {
    const NUMBER_BLOCK_SIZE_REGEXP = /(.{3})/g;

    return phoneNumber.replace(NUMBER_BLOCK_SIZE_REGEXP, '$1 ');
}
